import { Controller } from "@hotwired/stimulus"

// Drives the subtask import review modal: select all/none over the row
// checkboxes, a live "N of M selected" count, a count-aware submit label,
// and dimming excluded rows. Persistence stays with the form's include
// fields; this controller is presentation only.
export default class extends Controller {
  static targets = ["checkbox", "count", "submit"]

  connect() {
    this.refresh()
  }

  selectAll() {
    this.setAll(true)
  }

  selectNone() {
    this.setAll(false)
  }

  refresh() {
    const total = this.checkboxTargets.length
    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked).length

    this.countTarget.textContent = `${selected} of ${total} selected`
    this.submitTarget.value = selected === 1 ? 'Import 1 subtask' : `Import ${selected} subtasks`
    this.submitTarget.disabled = selected === 0
    this.checkboxTargets.forEach((checkbox) => this.markRow(checkbox))
  }

  setAll(checked) {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = checked })
    this.refresh()
  }

  markRow(checkbox) {
    const row = checkbox.closest('tr')
    row.classList.toggle('opacity-50', !checkbox.checked)
    row.querySelector('input[type="text"]')?.classList.toggle('text-decoration-line-through', !checkbox.checked)
  }
}
